<template>
  <div>
    <RateAgentFilterBox @on-refresh="onRefresh"/>
    <div class="data-content">
      <v-data-table :items=ratesAgent style="flex-grow: 1" :pagination.sync="pagination" :loading="loading" :total-items="pagination.totalItems" :rows-per-page-items="[5, 10]">
        <template v-slot:headers>
          <tr>
            <td
                v-for="header in headers"
                :key="header.text">
              <b style="text-transform: uppercase">{{header.text}}</b>
            </td>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td v-for="header of headers" :key="header.value">
              <span v-if="header.$value">{{header.$value(props.item)}}</span>
              <span v-else-if="header.id === 'sender_name'" style="display: flex; align-items: center">
              <img
                  :src="'/assets/icons/platform/'+props.item.channel+'.svg'"
                  :alt="props.item.channel"
                  class="mr-2"
                  style="width: 20px;height: 20px;"/>
                        <span>{{props.item.sender_name}}</span>
            </span>
            <span v-else-if="header.id === 'link_conversation'">
                <a :href="`/bot/${props.item.bot_code}/s/${props.item.sender_id}`" target="_blank">
                  <img style="position: relative;top: 5px;"
                       src="@/assets/icons/platform/conversation_history.svg"/>
                  <span style="padding: 0px 8px">{{$t('conversation')|capitalize}}</span>
                </a>
              </span>
              <span v-else>{{props.item[header.value]}}</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import RateAgentFilterBox from "@/views/rating-report/RateAgentFilterBox";
import {mapActions, mapState} from "vuex";
import {sync} from "vuex-pathify";
export default {
  name: "RateAgentDetails",
  components: {RateAgentFilterBox},
  computed: {
    ...mapState('rating', ['ratesAgent', 'loading']),
    pagination: sync('rating/pagination'),
    headers () {
      return this.$appService.correctHeaders([
        {
          text: this.$t('time'),
          value: 'created_time',
          $value: item => this.$filters.formatDateTime(item.created_time)
        },
        {
          text: this.$t('agent'),
          value: 'agent_email'
        },
        {
          text: this.$t('channel'),
          value: 'channel',
          type: 'custom',
          id: 'channel'
        },
        {
          text: this.$t('subChannel'),
          value: 'sub_channel',
          type: 'custom',
          id: 'sub_channel'
        },
        {
          text: this.$t('user'),
          value: 'sender_name',
          type: 'custom',
          id: 'sender_name'
        },
        {
          text: this.$t('senderId'),
          value: 'sender_id',
          type: 'custom',
          id: 'sender_id'
        },
        {
          text: this.$t('rated'),
          $value: item => item.rate_level + '⭐',
          type: 'custom',
          id: 'rate_level'
        },
        {
          text: this.$t('comment'),
          value: 'rate_content'
        },
        {
          text: this.$t(''),
          id: 'link_conversation'
        }
      ])
    }
  },
  methods: {
    ...mapActions('rating', ['listRateAgentDetails']),
    onRefresh() {
      this.listRateAgentDetails()
    }
  },
  watch: {
    pagination() {
      this.onRefresh()
    }
  }
}
</script>

<style scoped lang="scss">
.data-content {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  border: 1px solid #EDEDF2;
  border-radius: 5px;
  background-color: white;
}
</style>